import styled from 'styled-components';

const TabsRootElement = styled.div`
    background: #fff;
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset;
    position: sticky;
    top: 55px;
    z-index: 9;
    .profile-tab {
        button:first-child {
            margin-left: -18px;
        }
    }
    .tab-contact-bt{
        margin-left: auto;
        font-size: 14px !important;
        height: 32px;
        margin-top: 8px;
        padding: 0 10px 0px 12px !important;
        margin-right: 3px;
        flex:none;
        &:active, &:focus:active{
            padding: 0 10px 0px 12px;
            font-size: 14px;
        }
        @media (max-width: 1050px) {
           display:none;
        }
    }
    .tab-content-hide {
        display: none;
    }
`;
export default TabsRootElement;
